import { RouteConfig } from 'vue-router'
import { homeworkRoutes } from './RHomework'

const Center = () => import('../views/pe-homework/Center.vue')
const ClazzList = () => import('../views/pe-homework/ClazzList.vue')
const Clazz = () => import('../views/pe-homework/Clazz.vue')
const Student = () => import('../views/pe-homework/Student.vue')

const centerRoute: RouteConfig = {
  path: '/pe-homework-center',
  name: 'pe_homework_center',
  component: Center,
  props: (route) => ({ ...route.query, ...route.params }),
  children: [
    { ...homeworkRoutes[1], path: 'assign' },
    { ...homeworkRoutes.find((r) => r.path === '/homework-list')!, path: 'check' },
    {
      path: 'score',
      name: 'pe_homework_score',
      component: ClazzList,
      meta: {
        title: '体育作业评价',
      },
    },
  ],
}

const clazzRoute: RouteConfig = {
  path: '/pe-homework-clazz',
  name: 'pe_homework_clazz',
  component: Clazz,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '评价情况',
  },
}

const studentRoute: RouteConfig = {
  path: '/pe-homework-student',
  name: 'pe_homework_student',
  component: Student,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生详情',
  },
}

export default [centerRoute, clazzRoute, studentRoute]
